<template>
  <div class="tabs">
    <el-dialog title="调整入住方案" :visible.sync="dialogShow" width="800px" :before-close="handleClose">
      <div class="center">
        <div class="center-top">
          <div class="item" v-for="(room, roomIdx) in roomsList" :key="roomIdx + '_roomKey'">
            <span class="item-top">房间{{ roomIdx + 1 }}</span>
            <draggable v-model="roomsList[roomIdx]" class="item-bottom" ghostClass="ghost" :group="{
              name: 'people',
              put: true,
            }" animation="300" @start="onStart" :sort="false" @end="onEnd">
              <div v-for="item in room" class="item-person" :key="item.empId">
                {{ item.empName || '' }}
              </div>
            </draggable>
          </div>
        </div>
        <span class="center-span">拖动入住人到房间，实现调整入住方案</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handlerQuery">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { isEmptyObject } from '../../../utils/judge';
import { handleIntHotelRoom } from '../../../hooks/useHotel';
export default {
  components: { draggable },
  props: {
    dialogShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      drag: false,
      roomsList: [],
    }
  },
  computed: {
    ...mapState({
      rooms: state => state.intHt.rooms,
      htCnParams: (state) => state.intHt.htCnParams,
      htCnQuery: (state) => state.intHt.htCnQuery,
    }),
  },
  watch: {
    dialogShow() {
      if (!this.rooms || this.rooms.length == 0) {
        this.roomsList = [];
        return;
      }
      this.roomsList = this.$common.deepCopy(this.rooms);
      console.log('rooms === ', this.rooms);
    },
  },
  mounted() { },
  methods: {
    ...mapMutations({
      SET_STATE: 'intHt/SET_STATE',
      SET_HTCN_QUERY: 'intHt/SET_HTCN_QUERY', // 保存因共模式下的自定义信息
      SET_HTCN_PARAMS: 'intHt/SET_HTCN_PARAMS', // 设置查询参数
    }),
    onStart() {
      this.drag = true
    },
    //拖拽结束事件
    onEnd() {
      this.drag = false
    },
    handleClose() {
      this.$emit('update:dialogShow', false)
    },
    handlerQuery() {
      let arr = this.roomsList;
      let adultNum = this.htCnParams.adultNum || 1;
      let cxrs = [];
      let myRooms = [];
      for (let roomIdx = 0; roomIdx < arr?.length; roomIdx++) {
        let room = arr[roomIdx];
        if (!!room && room.length > adultNum) {
          this.$message.warning(`每间房最大不能超过${adultNum}人`);
          return;
        }
        if (room.length > 0) {
          let a = [...room]
          myRooms.push(a);
          room.forEach(emp => {
            if (!isEmptyObject(emp)) {
              cxrs.push(emp);
            }
          });
        }
      }

      let hotelRoom = handleIntHotelRoom({
        preCxrList: cxrs,
        rooms: myRooms,
      })

      this.SET_STATE({
        allRank: hotelRoom.allRank,
        rooms: hotelRoom.rooms,
        travelerIds: hotelRoom.travelerIds,
      })
      let queryobj = {};
      queryobj.roomNum = hotelRoom.roomNum;
      let empObj = {
        empRank: hotelRoom.minEmpRank, //   职级
        useNameclbz: hotelRoom.minEmpName, // 本次预订使用谁的差旅标准
      }

      // 因公
      if (this.htCnQuery.tripType == 1) {

      }
      this.SET_HTCN_QUERY(empObj)
      this.SET_HTCN_PARAMS(queryobj);

      this.$emit('handlerQuery', hotelRoom.rooms)
      this.$emit('update:dialogShow', false)
    },
  },
}
</script>

<style lang="scss" scoped="scoped">
.bottom-person {
  width: 80px;
  height: 40px;
  border: 1px solid #ddd;
  margin: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ghost {
  background-color: red !important;
}

/deep/ .el-dialog__footer {
  text-align: center;
}

.center {
  display: flex;
  flex-direction: column;

  .center-top {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-around;

    .item {
      width: 113px;
      //   height: 158px;
      border: 1px solid #0982df;
      margin: 10px 0;
      margin-right: 32px;

      .item-top {
        border-bottom: 1px solid #0982df;
        background-color: #eff8ff;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .item-bottom {
        height: 100px;
        flex: 1;

        .item-person {
          width: 80px;
          height: 30px;
          margin: 0 auto;
          border: 1px solid #ddd;
          margin-top: 5px;
          margin-bottom: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    .item:last-child {
      margin-right: 0px;
    }
  }

  .center-span {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .center-bottom {
    border: 1px solid #0982df;
    width: 100%;
    height: 120px;

    .item-top {
      border-bottom: 1px solid #0982df;
      background-color: #eff8ff;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;

      .bottom-drag {}
    }
  }
}
</style>
